import { BooleanFilterProps, FilterFormProps } from '@/models/FilterConfig';
import Checkbox from '@/components/ui/custom/dataInput/Checkbox';

const BooleanFilter = ({
  label,
  name,
  value = false,
  setValue,
}: BooleanFilterProps & FilterFormProps) => {
  return (
    <Checkbox
      id={name}
      onChange={({ target }) => setValue(name, target.checked)}
      checked={value}
      label={label}
      className={{
        div: 'flex flex-row-reverse justify-between w-full',
      }}
    />
  );
};

export default BooleanFilter;
